var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-toolbar" },
    [
      _c("button-fill", {
        attrs: {
          disabled: _vm.pendingTasksButtonDisabled,
          "disabled-label": "No pending tasks",
          label: _vm.pendingTasksButtonLabel,
          size: "small",
          tag: "router-link",
          to: {
            name: "workflow/pending",
            params: { clusterName: _vm.clusterName }
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46e56500", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e56500","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-history/components/footer-toolbar.vue
// module id = 1598
// module chunks = 0